import { Button, Switch, Form, FormItem, Input, Select, Option, Col, Row, Message, MessageBox, Container, Aside, Header, Main, Footer, Menu, MenuItem, Submenu, Table, TableColumn, Pagination, Tabs, TabPane, DatePicker, Radio, RadioGroup, RadioButton, Loading, Checkbox,CheckboxButton, CheckboxGroup, Dialog, InputNumber, Breadcrumb, BreadcrumbItem, PageHeader, Upload, Popover } from 'element-ui';
// 导出
export default (app) => {
    app.use(Button);
    app.use(Switch);
    app.use(Form);
    app.use(FormItem);
    app.use(Input);
    app.use(Col);
    app.use(Row);
    app.use(Container);
    app.use(Aside);
    app.use(Header);
    app.use(Main);
    app.use(Footer);
    app.use(Menu);
    app.use(MenuItem);
    app.use(Submenu);
    app.use(Select);
    app.use(Option);
    app.use(Table);
    app.use(TableColumn);
    app.use(Pagination);
    app.use(Tabs);
    app.use(TabPane);
    app.use(DatePicker);
    app.use(Radio);
    app.use(RadioGroup);
    app.use(RadioButton);
    app.use(Checkbox);
    app.use(CheckboxButton);
    app.use(CheckboxGroup);
    app.use(Dialog);
    app.use(InputNumber);
    app.use(Breadcrumb);
    app.use(BreadcrumbItem);
    app.use(PageHeader);
    app.use(Upload);
    app.use(Popover);
    app.use(Loading.directive);
    app.prototype.$loading = Loading.service;
    app.prototype.$message = Message;
    app.prototype.$msgbox = MessageBox;
    app.prototype.$alert = MessageBox.alert;
    app.prototype.$confirm = MessageBox.confirm;
    app.prototype.$prompt = MessageBox.prompt;
}


// WEBPACK FOOTER //
// ./src/plugins/elementui.js